import React from 'react';

const JobsOverview = ({ jobs }) => {
  const stats = {
    assigned: jobs.length,
    attended: jobs.filter(
      (job) => job.studentJobResponse === 'Will Attend'
    ).length,
    notAttended: jobs.filter(
      (job) => job.studentJobResponse === 'Cannot Attend'
    ).length,
    rejected: jobs.filter(
      (job) =>
        job.overallStatus === 'Rejected' ||
        job.overallStatus === 'Not Selected' ||
        job.rounds?.some((round) =>
          ['Rejected', 'Not Selected', 'Not Shortlisted'].includes(round.status)
        )
    ).length,
    selected: jobs.filter((job) => job.overallStatus === 'Selected').length,
    offerAccepted: jobs.filter((job) => job.studentRevert === 'Accepted')
      .length,
    offerRejected: jobs.filter((job) =>
      ['Declined', 'Auto Declined'].includes(job.studentRevert)
    ).length,
  };

  const cards = [
    { label: 'Assigned', value: stats.assigned, color: 'bg-blue-100 text-blue-800' },
    { label: 'Attended', value: stats.attended, color: 'bg-green-100 text-green-800' },
    { label: 'Not Attended', value: stats.notAttended, color: 'bg-red-100 text-red-800' },
    { label: 'Rejected', value: stats.rejected, color: 'bg-red-100 text-red-800' },
    { label: 'Selected', value: stats.selected, color: 'bg-green-100 text-green-800' },
    { label: 'Offer Accepted', value: stats.offerAccepted, color: 'bg-green-100 text-green-800' },
    { label: 'Offer Rejected', value: stats.offerRejected, color: 'bg-red-100 text-red-800' },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7">
      {cards.map((card) => (
        <div
          key={card.label}
          className="flex flex-col items-center justify-center rounded-lg border border-gray-200 bg-white px-4 py-4 text-center shadow-sm dark:border-white/10 dark:bg-navy-800"
        >
          <span className="text-2xl font-bold text-navy-700 dark:text-white">
            {card.value}
          </span>
          <span className={`mt-2 inline-block rounded-lg px-2 py-1 text-sm font-medium ${card.color}`}>
            {card.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default JobsOverview;
